import { getStafferGigsTemplatesListQueryKey, getStafferGigsTemplatesListQueryOptions } from "@sidegigllc/api/client";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { gigTemplateSchema } from "api/resources/templates";

// ---- Gig (Request-a-Pro) templates (/staffer/gigs/templates/) ---------------
// Writes go straight through the generated hooks; forms build the payload. Read parses per-row so one
// bad legacy row can't blank the whole list.
export const selectGigTemplates = (templates: Array<unknown>) =>
  templates
    .flatMap((template) => {
      const parsed = gigTemplateSchema.safeParse(template);
      return parsed.success ? [parsed.data] : [];
    })
    .toSorted((a, b) => a.name.localeCompare(b.name));

export const gigTemplatesQueryOptions = (
  ...[params, options]: Parameters<typeof getStafferGigsTemplatesListQueryOptions>
) =>
  getStafferGigsTemplatesListQueryOptions(params, {
    ...options,
    query: { ...options?.query, select: selectGigTemplates },
  });

export const useGigTemplates = (...[params, options]: Parameters<typeof getStafferGigsTemplatesListQueryOptions>) => {
  const queryClient = useQueryClient();
  const query = useQuery(gigTemplatesQueryOptions(params, options));
  return {
    ...query,
    invalidate: () => queryClient.invalidateQueries({ queryKey: getStafferGigsTemplatesListQueryKey(params) }),
  };
};
